import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail, Facebook, Instagram, Linkedin, LogIn } from 'lucide-react';
import { Button } from './ui/button';
import logoImage from '../assets/images/Insight-Digital-Agency_LogoDesign_For-Web-01.png';

const Header = ({ onBookMeeting }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'About', href: '/about' },
    { name: 'Blog', href: '/blogs' },
    { name: 'Contact', href: '/contact' },
    // { name: 'Snapshot Report', href: '/snapshot-report' },
  ];

  const isActive = (path) => location.pathname === path;

  const handleBookMeeting = () => {
    if (onBookMeeting) {
      onBookMeeting();
    }
    setIsMenuOpen(false); // Close mobile menu if open
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50 border-b border-gray-100">
      {/* Premium Top Bar - Hidden on mobile, shown on desktop */}
      <div className="hidden lg:block bg-gradient-to-r from-slate-800 via-slate-700 to-slate-800 text-white py-0.5">
        <div className="container mx-auto px-6 flex justify-between items-center text-sm min-h-0 py-0.5">
          {/* Left side intentionally left empty for alignment */}
          <div></div>
          {/* Right side: Social links, then contact info, then SMB Login */}
          <div className="flex items-center space-x-8">
            <div className="flex items-center space-x-5">
              <a href="https://www.facebook.com/InsightDigitalAgency" target="_blank" rel="noopener noreferrer" className="hover:text-orange-300 transition-all duration-300 hover:scale-110 p-1">
                <Facebook size={16} />
              </a>
              <a href="https://www.instagram.com/InsightDigitalAgencyKC/" target="_blank" rel="noopener noreferrer" className="hover:text-orange-300 transition-all duration-300 hover:scale-110 p-1">
                <Instagram size={16} />
              </a>
              <a href="https://www.linkedin.com/in/insightdigitalagency/" target="_blank" rel="noopener noreferrer" className="hover:text-orange-300 transition-all duration-300 hover:scale-110 p-1">
                <Linkedin size={16} />
              </a>
            </div>
            <div className="flex items-center space-x-8">
              <a href="tel:913-513-1525" className="flex items-center space-x-2 hover:text-orange-300 transition-all duration-300 group">
                <Phone size={16} className="group-hover:scale-110 transition-transform" />
                <span className="font-medium">913-513-1525</span>
              </a>
              <a href="mailto:info@insightdigitalagency.com" className="flex items-center space-x-2 hover:text-orange-300 transition-all duration-300 group">
                <Mail size={16} className="group-hover:scale-110 transition-transform" />
                <span className="font-medium">info@insightdigitalagency.com</span>
              </a>
            </div>
            <a
              href="https://bizapp.insightdigitalagency.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-4 flex items-center border border-white text-white px-3 py-1.5 rounded-md font-medium hover:bg-white hover:text-slate-800 transition-all duration-300 text-sm shadow-none"
            >
              <LogIn size={16} className="mr-2" /> BizApp Login
            </a>
          </div>
        </div>
      </div>

      {/* Premium Main Navigation */}
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center py-3 min-h-0">
          {/* Clean Premium Logo Area */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img src={logoImage} alt="Insight Digital Agency" className="h-10 sm:h-12 w-auto transition-all duration-300 group-hover:scale-105" />
          </Link>

                     {/* Clean Premium Navigation */}
           <nav className="hidden lg:flex items-center space-x-8">
             {navigation.map((item) => (
               <Link
                 key={item.name}
                 to={item.href}
                 className={`relative text-gray-600 hover:text-blue-600 transition-all duration-300 font-medium py-3 px-2 ${
                   isActive(item.href) ? 'text-blue-600 font-semibold' : ''
                 }`}
               >
                 {item.name}
                 {isActive(item.href) && (
                   <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-600"></span>
                 )}
               </Link>
             ))}
             <Button 
               onClick={handleBookMeeting}
               className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2.5 rounded-lg font-semibold transition-all duration-300 shadow-md hover:shadow-lg ml-4"
             >
               Book a Free Call
             </Button>
           </nav>

          {/* Premium Mobile Menu Button */}
          <button
            className="lg:hidden p-3 rounded-xl bg-gray-50 hover:bg-gray-100 transition-all duration-300"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} className="text-gray-700" /> : <Menu size={24} className="text-gray-700" />}
          </button>
        </div>

        {/* Premium Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-6 border-t border-gray-100 bg-gradient-to-b from-white to-gray-50">
            <nav className="flex flex-col space-y-1">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-all duration-300 font-semibold py-4 px-4 rounded-lg ${
                    isActive(item.href) ? 'text-blue-600 bg-blue-50' : ''
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <div className="pt-4">
                <Button 
                  onClick={handleBookMeeting}
                  className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-8 py-3 rounded-xl font-bold shadow-lg w-full"
                >
                  Book a Free Call
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;

